import IMask from 'imask';
import { mount } from '../dom-lifecycle';

mount('[data-mask]', function () {
	let el = this;

	// Pola telefonu: wytnij prefiks kraju z autouzupełniania ("+48 660 466 989" → "660 466 989").
	// MUSI zadziałać ZANIM imask przetworzy wartość (imask obciąłby do pierwszych 9 cyfr),
	// dlatego rejestrujemy natywny listener PRZED utworzeniem imask. Ruszamy tylko przy
	// nadmiarze cyfr (>9), żeby nie przeszkadzać zwykłemu wpisywaniu/formatowaniu.
	let isTel = el.getAttribute('autocomplete') === 'tel' || el.getAttribute('inputmode') === 'tel';
	if (isTel) {
		let stripCountryPrefix = () => {
			let digits = el.value.replace(/\D/g, '');
			if (digits.length > 9) {
				el.value = digits.slice(-9);
			}
		};
		el.addEventListener('input', stripCountryPrefix);
		el.addEventListener('change', stripCountryPrefix);
		stripCountryPrefix(); // obsłuż wartość już wstawioną przez autouzupełnianie przed startem JS
	}

	let imask = el._imask = new IMask(el, {
		mask: el.dataset.mask.startsWith('/') && el.dataset.mask.endsWith('/') ?
			new RegExp(el.dataset.mask.slice(1, -1)) :
			el.dataset.mask,
	});
	$(el).on('input', () => imask.value = el.value);
	$(el.form).on('reset', () => imask.masked.reset());
	let update = () => $(el).toggleRuleValid('mask', imask.masked.isComplete);
	imask.on('accept', update);
	update();
});

mount('[data-repeat]', function () {
	let repeatedInput = this.form.elements[this.dataset.repeat];
	let update = () => $(this).toggleRuleValid('repeat', this.value == repeatedInput.value);
	$([this, repeatedInput]).on('input change', update);
	update();
});

mount('[data-no-paste]', function () {
	this.addEventListener('paste', e => e.preventDefault());
	this.addEventListener('drop', e => e.preventDefault());
});